<template>
  <div class="no-content">
    <img src="/image/no-search-data.svg" />
    <div class="text">{{ content || $t('common.emptyDefaultTxt') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.no-content {
  padding-top: 84px;
  position: relative;
  padding-bottom: 100px;

  img {
    width: 292rpx;
    height: 246rpx;
    display: block;
    margin: 0 auto;
  }

  .text {
    width: 100%;
    position: absolute;
    bottom: 64px;
    text-align: center;
    font-size: 16px;
    color: #888888;
  }
}
</style>
